<template>
	<el-menu router :default-active="$route.meta.active" unique-opened class="el-menu-vertical" background-color="#2a3542"
			text-color="#fff" active-text-color="#ffd04b" :collapse-transition="false" :collapse="collapse">
			<el-menu-item index="console" :route="{path:'/console'}">
				<i class="el-icon-s-platform"></i>
				<span slot="title">控制台</span>
			</el-menu-item>
			<el-menu-item index="order" :route="{name:'order'}">
				<i class="el-icon-s-order"></i>
				<span slot="title">订单管理</span>
			</el-menu-item>
			<el-menu-item index="driver" :route="{path:'/driver'}">
				<i class="el-icon-s-custom"></i>
				<span slot="title">司机管理</span>
			</el-menu-item>
			<el-menu-item index="user" :route="{name:'user'}">
				<i class="el-icon-user-solid"></i>
				<span slot="title">用户管理</span>
			</el-menu-item>
			<el-menu-item index="marketing" :route="{name:'marketing'}">
				<i class="el-icon-s-marketing"></i>
				<span slot="title">营销管理</span>
			</el-menu-item>
			<el-menu-item index="total" :route="{name:'total'}">
				<i class="el-icon-s-data"></i>
				<span slot="title">数据统计</span>
			</el-menu-item>
			<el-menu-item index="operate" :route="{name:'operate'}">
				<i class="el-icon-s-opportunity"></i>
				<span slot="title">运营设置</span>
			</el-menu-item>
			<el-menu-item v-if="adminInfo && adminInfo.super" index="system" :route="{name:'system'}">
				<i class="el-icon-s-grid"></i>
				<span slot="title">系统管理</span>
			</el-menu-item>
	</el-menu>
</template>

<script>
	export default {
		data() {
			return {
				collapse: false,
				adminInfo: null
			}
		},
		mounted() {
			const that = this;
			const info = localStorage.getItem("_JIAZHI_info");
			if (Boolean(info)) {
				that.adminInfo = JSON.parse(info);
			}
		},
		methods: {
			onCollapse() {
				this.collapse = !this.collapse;
			}
		}
	}
</script>

<style scoped>
	.el-menu {
		width: 10rem;
		border-right: 0;
		user-select: none;
	}

	.el-menu--collapse {
		width: 5rem !important;
	}

	.el-menu-item {
		margin: 0.625rem;
	}

	.el-menu-item i {
		color: white;
	}

	.el-menu-item span {
		position: relative;
	}

	.el-menu-item span .dotn {
		position: absolute;
		top: 50%;
		right: -0.9375rem;
		border-radius: 50%;
		margin-top: -3px;
		border: 3px red solid;
	}

	.el-menu-item.is-active i {
		color: #ffd04b;
	}

	.el-menu-item.is-active {
		border-radius: 0.3125rem;
		background-color: #373f4b !important;
	}

	.el-menu-item,
	.el-submenu__title {
		height: 2.8rem !important;
		line-height: 2.8rem !important;
	}

	.el-submenu__title span {
		position: relative;
	}

	.el-submenu__title span .dot {
		position: absolute;
		top: 50%;
		right: -0.9375rem;
		border-radius: 50%;
		margin-top: -3px;
		border: 3px red solid;
	}

	.el-menu-item:hover,
	.el-submenu>>>.el-submenu__title:hover {
		border-radius: 0.3125rem;
		background-color: #373f4b !important;
	}

	.el-submenu {
		margin: 0.625rem;
		overflow: hidden;
	}

	.el-submenu>>>.el-submenu__title i {
		color: white;
	}

	.el-submenu i.el-icon-d-arrow-right {
		font-size: 0.75rem;
		margin-top: 0.125rem;
		margin-right: 0;
	}

	.el-submenu>>>.el-submenu__title i.el-submenu__icon-arrow {
		font-size: 1rem;
	}

	.el-submenu.is-opened>>>.el-submenu__title {
		border-top-left-radius: 0.3125rem;
		border-top-right-radius: 0.3125rem;
		background-color: #373f4b !important;
	}

	.el-submenu>>>.el-menu .el-menu-item {
		padding-left: 1.875rem !important;
		background-color: #373f4b !important;
	}

	.el-submenu>>>.el-menu .el-menu-item.is-active {
		border-radius: 0;
	}

	.el-submenu>>>.el-menu .el-menu-item:hover {
		border-radius: 0;
		background-color: #47505d !important;
	}

	.el-submenu.is-opened>>>.el-submenu__title:hover {
		border-top-left-radius: 0.3125rem !important;
		border-top-right-radius: 0.3125rem !important;
		border-bottom-left-radius: 0;
		border-bottom-right-radius: 0;
		background-color: #373f4b !important;
	}

	.el-submenu>>>.el-menu .el-menu-item:last-child {
		border-bottom-left-radius: 0.3125rem;
		border-bottom-right-radius: 0.3125rem;
	}

	.el-submenu .el-menu-item {
		min-width: auto;
		margin: 0;
	}

	>>>.el-menu--vertical .el-icon-d-arrow-right {
		font-size: 0.875rem;
	}
</style>
